export default __webpack_public_path__ + "static/media/spatialdj.03929c12.png";